import { baseAPI, baseTransformResponse3 } from 'api/baseApi'
import { ApiResponce } from 'types'
import {
 TCallStatusResponse,
 TInitiateCallBody,
 TInitiateCallResponse,
} from '../types'

export const callsApi = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  initiateCall: mutation<TInitiateCallResponse, TInitiateCallBody>({
   query: (body) => ({
    url: 'user/calls/initiate',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse3,
  }),
  getCallStatus: query<TCallStatusResponse, { id: number | string }>({
   query: ({ id }) => ({
    url: `user/calls/${id}/status`,
    method: 'get',
   }),
   transformResponse: (res: ApiResponce) => res.data,
  }),
 }),
})

export const { useInitiateCallMutation, useGetCallStatusQuery } = callsApi
